import { Component } from '@angular/core';
import { SharedService, FreeBetService, promoBetType } from 'baseline-lib';
import { Global } from '../../../global/global';
import { ModalController} from 'ionic-angular';
import { LoginModalPage } from '../../shared/login-modal/login-modal';


/**
 * Generated class for the FreeBetComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'free-bet',
  templateUrl: 'free-bet.html'
})
export class FreeBetComponent {

  text: string;

  constructor(private _freeBetService: FreeBetService,  private _sharedService: SharedService, public globalData:Global, public modalCtrl : ModalController) {
    console.log('Hello FreeBetComponent Component');
    this.text = 'Hello World';
  }

  ngOnInit() { 
    this._freeBetService.getPromoBet(this._sharedService.selectedGameType.gtid, promoBetType.freeBet);
  }

  validate(sel){
    if (this.globalData.isLoggedIn && this.globalData.authUser){
      this._freeBetService.validate(sel);  
    }else{
      let profileModal = this.modalCtrl.create(LoginModalPage);
      profileModal.present();    
    }
  }

  placeBet(){
    this._freeBetService.placeBet();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/free-bet/free-bet.ts